import { availabilitySummary } from "@/services/naaviApi/internalService";
import { toStartOfDayIso } from "@/helpers/dateHelper";
import { resolveMediaUrl } from "@/helpers/assetHelper";
import type { AvailabilityDoctorSummary } from "@/services/naaviApi/types";

export type FeaturedDoctor = {
  id: number | string;
  resourceId: number;
  tenantId: string;
  tenantXId: string;
  name: string;
  image: string;
  specialty: string;
};

const SEARCH_TYPE_FULL_DAY = 2;
const DEFAULT_LIMIT = 6;

function mapFeaturedDoctor(summary: AvailabilityDoctorSummary): FeaturedDoctor {
  const resolvedId = summary.userId ?? summary.resourceId;
  const rawImage = summary.userAvatarUrl ?? summary.tenantLogo ?? "";

  return {
    id: resolvedId,
    resourceId: summary.resourceId,
    tenantId: summary.tenantId,
    tenantXId: summary.tenantXId,
    name: summary.userName ?? summary.resourceName ?? "",
    image: resolveMediaUrl(rawImage, { tenantId: summary.tenantId }),
    specialty: summary.userSpecialty ?? "",
  };
}

export async function fetchFeaturedDoctors(
  limit: number = DEFAULT_LIMIT,
): Promise<FeaturedDoctor[]> {
  const baseDate = new Date();
  baseDate.setHours(0, 0, 0, 0);

  const payload = {
    date: toStartOfDayIso(baseDate),
    concept: 0,
    searchType: SEARCH_TYPE_FULL_DAY,
    page: 1,
    pageSize: limit,
  };

  const response = await availabilitySummary(payload);
  const items = Array.isArray(response?.items) ? response.items : [];
  return items.map(mapFeaturedDoctor);
}
